import { render } from "./App.vue?vue&type=template&id=7ac258d0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7ac258d0&lang=scss"

import exportComponent from "/Users/amane/Documents/-4°/AmaneStudio/A++/Amane.dev/amane_dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__